'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _editContactphoneModal = require('./editContactphone.modal.html');

var _editContactphoneModal2 = _interopRequireDefault(_editContactphoneModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactPhonesController = function () {
  function ContactPhonesController($scope, $uibModal, lookupService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactPhonesController);
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.lookupService = lookupService;

    this.initializeEnumLookups();

    this.errMsg = '';
  }

  (0, _createClass3.default)(ContactPhonesController, [{
    key: 'initializeEnumLookups',
    value: function initializeEnumLookups() {
      var _this = this;

      var ctrl = this;
      ctrl.selectDefaults = {};

      var lookups = ['PhoneType'];

      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
        var pleaseSelectOption = { id: null, name: 'Please Select' };
        enumLookupCollection.phoneType.unshift(pleaseSelectOption);

        _this.enumLookupCollection = enumLookupCollection;
        _this.selectDefaults.phoneType = pleaseSelectOption;
      });
    }
  }, {
    key: 'editContactPhone',
    value: function editContactPhone(phone) {
      this.errMsg = '';
      this.saveButtonTitle = 'Add';

      if (phone) {
        this.selectDefaults.phoneType = (0, _lodash.find)(this.enumLookupCollection.phoneType, function (o) {
          return o.id === phone.phoneType;
        });
        this.tempPhoneNo = phone.phone;

        phone.editMode = true;
        this.editPhone = phone;

        this.saveButtonTitle = 'Update';
      }

      this.$uibModalInstance = this.$uibModal.open({
        template: _editContactphoneModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.selectDefaults.phoneType = this.enumLookupCollection.phoneType[0];
      this.tempPhoneNo = '';
      this.$uibModalInstance.close();

      if (this.editPhone) {
        this.editPhone.editMode = false;
      }
    }
  }, {
    key: 'addPhone',
    value: function addPhone() {
      var _this2 = this;

      if (this.selectDefaults.phoneType.id === null) {
        this.errMsg = 'Please select a Phone Type';
        return;
      }

      if (!this.tempPhoneNo) {
        this.errMsg = 'Please enter a Phone Number';
        return;
      }

      var phone = (0, _lodash.find)(this.container.contactPhones, function (o) {
        return !o.editMode && o.phone === _this2.tempPhoneNo;
      });
      if (phone) {
        this.errMsg = 'This Phone No is already added to the list';
        return;
      }

      if (!this.editPhone) {
        this.container.contactPhones.push({
          phoneType: this.selectDefaults.phoneType.id,
          phoneTypeName: this.selectDefaults.phoneType.name,
          phone: this.tempPhoneNo
        });
      } else {
        this.editPhone.phoneType = this.selectDefaults.phoneType.id;
        this.editPhone.phoneTypeName = this.selectDefaults.phoneType.name;
        this.editPhone.phone = this.tempPhoneNo;
      }

      this.closeModal();
    }
  }, {
    key: 'removePhone',
    value: function removePhone(phone) {
      this.container.contactPhones = (0, _lodash.without)(this.container.contactPhones, phone);
    }
  }]);
  return ContactPhonesController;
}();

exports.default = ContactPhonesController;


// WEBPACK FOOTER //
// ./client/app/components/common/contactPhones/contactPhones.controller.js